module.exports = __webpack_public_path__ + "static/media/hwexe_background_3.b0d4a192.mp3";